import React from 'react';
import { tokens } from '../../styles/tokens';
import { useTheme } from '../../context/ThemeContext';
import { localizeItem } from '../../hooks/useLanguage';
import OptimizedImage from '../ui/OptimizedImage';
import { formatRestaurantPrice } from '../../utils/formatPrice';

const defaultT = { willBeLater: 'будет позже', addItem: 'Добавить', addMore: 'Ещё' };

export function MenuCard({ item, quantity, onAdd, onClick, lang = 'ru', t = defaultT, currency = 'UZS' }) {
  const theme = useTheme();
  const { colors } = theme;
  const isUnavailable = !item.is_available;
  const hasImage = item.image_url;

  const S = {
    card: {
      backgroundColor: colors.bgCard,
      borderRadius: tokens.radius.lg,
      overflow: 'hidden',
      cursor: 'pointer',
      transition: `transform ${tokens.transition.fast}, background-color 0.3s`,
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
    },
    imageWrap: {
      width: '100%',
      paddingTop: '75%',
      position: 'relative',
      backgroundColor: colors.bgChip,
      overflow: 'hidden',
    },
    imagePlaceholder: {
      position: 'absolute',
      inset: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '40px',
    },
    badge: {
      position: 'absolute',
      top: '10px',
      left: '10px',
      backgroundColor: colors.badgeBg,
      color: '#fff',
      fontSize: tokens.font.sizes.xs,
      fontWeight: tokens.font.weights.semibold,
      padding: '4px 10px',
      borderRadius: tokens.radius.full,
      backdropFilter: 'blur(8px)',
    },
    body: {
      padding: '12px',
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
    },
    name: {
      fontSize: tokens.font.sizes.sm,
      color: colors.text,
      lineHeight: '1.3',
      fontWeight: tokens.font.weights.medium,
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      flex: 1,
      minWidth: 0,
    },
    price: {
      fontSize: tokens.font.sizes.sm,
      fontWeight: tokens.font.weights.semibold,
      color: colors.textSecondary,
    },
    footer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: '6px',
      gap: '8px',
    },
    weight: {
      fontSize: tokens.font.sizes.xs,
      color: colors.textSecondary,
    },
    addBtn: {
      width: '36px',
      height: '36px',
      borderRadius: tokens.radius.md,
      backgroundColor: colors.accent,
      border: 'none',
      color: '#fff',
      fontSize: '22px',
      lineHeight: 1,
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: `background ${tokens.transition.fast}, transform ${tokens.transition.fast}`,
      flexShrink: 0,
      padding: 0,
    },
    arrowBtn: {
      width: '36px',
      height: '36px',
      borderRadius: tokens.radius.md,
      backgroundColor: colors.bgChip,
      border: 'none',
      color: colors.textSecondary,
      fontSize: '18px',
      cursor: 'default',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 0,
    },
  };

  const handleAdd = (e) => {
    e.stopPropagation();
    if (!isUnavailable) onAdd(item);
  };

  return (
    <div
      style={S.card}
      onClick={() => onClick(item)}
      onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.02)'; }}
      onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
    >
      <div style={S.imageWrap}>
        {hasImage ? (
          <OptimizedImage
            src={item.image_url}
            alt={item.name_ru || item.name}
            borderRadius={tokens.radius.lg}
          />
        ) : (
          <div style={S.imagePlaceholder}>🍽️</div>
        )}
        {isUnavailable && (
          <div style={S.badge}>{t.willBeLater}</div>
        )}
        {quantity > 0 && !isUnavailable && (
          <div style={{
            ...S.badge,
            left: 'auto',
            right: '10px',
            backgroundColor: colors.accent,
          }}>
            {quantity}
          </div>
        )}
      </div>

      <div style={S.body}>
        <div style={S.name}>{localizeItem(item, lang)}</div>
        <div style={S.price}>{formatRestaurantPrice(item.price, currency)}</div>
        <div style={S.footer}>
          <span style={S.weight}>{item.weight || ''}</span>
          {isUnavailable ? (
            <div style={S.arrowBtn}>›</div>
          ) : (
            <button style={S.addBtn} onClick={handleAdd} aria-label={quantity === 0 ? t.addItem : t.addMore}>
              <span style={{ display: 'block', lineHeight: 1 }}>+</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
